import { TFloorParams } from 'common/types/floor-params.type';
import { getAreaUser } from 'pages/common/helpers/get-area-user.helper';
import { FLOOR_COVERING_CONFIGURATION_TYPE } from 'pages/common/const';

type TParams = {
  authorizedCustomerId: string | undefined;
  unauthorizedCustomerId: string | undefined;
  isKazakhstan: boolean;
  inputParams: TFloorParams;
  calculatorId: string;
  typeInstallation: string | null;
};

type TProjectConfigurationParameters = {
  inputParams: TFloorParams;
  calculatorId: string;
  typeInstallation: string | null;
};

type TProjectConfigurationParameter = {
  key: string;
  value: string;
};

const getProjectConfigurationParameters = ({
  inputParams,
  calculatorId,
  typeInstallation,
}: TProjectConfigurationParameters): Array<TProjectConfigurationParameter> => {
  const area = getAreaUser(inputParams);
  let projectConfigurationParameters = [
    {
      key: 'calculatorId',
      value: calculatorId,
    },
    {
      key: 'area',
      value: area.toString(),
    },
  ];

  if (inputParams.length) {
    projectConfigurationParameters.push({
      key: 'length',
      value: inputParams.length.toString(),
    });
  }

  if (inputParams.width) {
    projectConfigurationParameters.push({
      key: 'width',
      value: inputParams.width.toString(),
    });
  }

  if (typeInstallation) {
    projectConfigurationParameters.push({
      key: 'layingType',
      value: typeInstallation,
    });
  }

  return projectConfigurationParameters;
};

export const getCreateConfigurationBody = ({
  authorizedCustomerId,
  unauthorizedCustomerId,
  isKazakhstan,
  inputParams,
  calculatorId,
  typeInstallation,
}: TParams) => {
  const isAuthorized = Boolean(authorizedCustomerId);
  const customerId = isAuthorized ? authorizedCustomerId : unauthorizedCustomerId;
  return {
    isAuthorized,
    customerId,
    configurationType: FLOOR_COVERING_CONFIGURATION_TYPE,
    buCode: isKazakhstan ? 40 : 9,
    currency: isKazakhstan ? 'KZT' : 'RUB',
    projectConfigurationParameters: getProjectConfigurationParameters({
      inputParams,
      calculatorId,
      typeInstallation,
    }),
  };
};
